'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-cd939937.js');
var errors_errorCodes = require('./errorCodes.js');
var errors_appError = require('./appError.js');

/**
 * @param error {Error|Object} - target error
 * @param resAsInst {Boolean} - return response as AppError instance or object
 * @param response {Response} - fetch response object (network response object)
 * */
function formatError(error, resAsInst, response) {
    var _a, _b, _c;
    if (resAsInst === void 0) { resAsInst = false; }
    if (response === void 0) { response = null; }
    var message = '';
    var amsMessage = '';
    var name = 'Unknown error';
    var netCode = null;
    var amsCode = null;
    var errCode = errors_errorCodes.ErrorCodes.NET_ERR;
    var errorField = null;
    if (response === null || response === void 0 ? void 0 : response.statusText) {
        name = message = response.statusText;
    }
    if (response === null || response === void 0 ? void 0 : response.status) {
        netCode = response.status;
    }
    if ((error instanceof TypeError)) {
        errCode = response ? errors_errorCodes.ErrorCodes.NET_ERR : errors_errorCodes.ErrorCodes.APP_ERR;
        message = error.message;
        name = error.name;
    }
    else if ((error instanceof Error)) {
        errCode = response ? errors_errorCodes.ErrorCodes.NET_ERR : errors_errorCodes.ErrorCodes.APP_ERR;
        message = error.message;
        name = error.name;
    }
    else { //AMS response
        if ((_a = error === null || error === void 0 ? void 0 : error.info) === null || _a === void 0 ? void 0 : _a.msg) {
            name = 'Backend';
            amsMessage = message = error.info.msg;
            amsCode = error.info.status;
            errCode = errors_errorCodes.ErrorCodes.AMS_ERR;
        }
        else if ((_b = error === null || error === void 0 ? void 0 : error.st) === null || _b === void 0 ? void 0 : _b.code) {
            name = 'Backend';
            amsCode = error.st.code;
            amsMessage = message = error.st.info;
            errCode = errors_errorCodes.ErrorCodes.AMS_ERR;
            if ((_c = error === null || error === void 0 ? void 0 : error.st) === null || _c === void 0 ? void 0 : _c.error_field) {
                errorField = error.st.error_field;
            }
        }
        else if (error === null || error === void 0 ? void 0 : error.error) {
            name = 'Backend';
            amsMessage = message = error.error;
            errCode = errors_errorCodes.ErrorCodes.AMS_ERR;
        }
        else {
            if (error === null || error === void 0 ? void 0 : error.message) {
                message = error.message;
            }
            if (error === null || error === void 0 ? void 0 : error.name) {
                name = error.name;
            }
        }
    }
    var respErrorData = {
        amsMessage: amsMessage,
        name: name,
        amsCode: amsCode,
        netCode: netCode,
        errCode: errCode,
        message: message,
        errorField: errorField,
        origError: error
    };
    if (resAsInst) {
        var name_1 = respErrorData.name, message_1 = respErrorData.message, errCode_1 = respErrorData.errCode, meta = tslib_es6.__rest(respErrorData, ["name", "message", "errCode"]);
        return new errors_appError.AppError(errCode_1, name_1, message_1, meta);
    }
    return respErrorData;
}

exports.formatError = formatError;
